// @core/api/endpoints/document/create_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateNumberingSchemeRequest,
  NumberingSchemeResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create numbering scheme
 * Creates a new auto-numbering scheme for documents.
 */
export async function CreateNumberingScheme(
  data: CreateNumberingSchemeRequest,
  options?: RequestOptions
): Promise<NumberingSchemeResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/numbering-schemes`;
  const requestOptions = options;
  return client.post<NumberingSchemeResponse>(requestPath, data, requestOptions);
}
